import { render, staticRenderFns } from "./ChooseColor.vue?vue&type=template&id=1a67815a&"
import script from "./ChooseColor.vue?vue&type=script&lang=js&"
export * from "./ChooseColor.vue?vue&type=script&lang=js&"
import style0 from "./ChooseColor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports